const messages = {
    auth: {
        loggingIn: 'Logging In',
        loadingSiteData: 'Loading site data',
        refreshingDenyReasons: 'Refreshing deny reasons',
        refreshingFuelTypes: 'Refreshing fuel types',
        refreshingTravelMethods: 'Refreshing travel methods',
        loadingLocationData: 'Loading location data',
        permissionsError: 'Sorry, you do not have the necessary permissions to access the application',
        noCardData: 'It was not possible to retrieve cardholder information at this time',
        accessDeniedWithReason: (reason) => `Login failed due to the following: ${reason}`,
        invalidCode: 'Invalid authentication code',
        preferredOptionUnavailable: 'Preferred option unavailable?',
        noContactDetails: "It's because we don't currently have your contact details stored.",
        useProductLink: (myProductName) => `You can add or update these via the ${myProductName} button below`,
        sendAuthCodeMessage: { __html: 'To ensure access to cardholder data is secured, you will need to <strong>request</strong> an authentication code via <strong>email</strong> or <strong>SMS</strong> the first time you log into the app.' },
        selectMessageOption: 'Please select below which method you would prefer and click Send.',
        authCodeHeader: 'Authentication code',
        authCodePlaceholder: 'Authentication Code',
        enterCodeBelow: 'Once you have received your authentication code, enter it below and click the \'Authenticate\' button',
        authenticateButton: 'Authenticate',
        sendText: 'Send',
        smsLabel: 'SMS',
        emailLabel: 'Email',
    },
    manualLookup: {
        preambleMessage: 'Enter the details of the card holder below to find them in the system',
        surnameLabel: 'Surname:',
        initialLabel: 'Initial:',
        dateOfBirthLabel: 'Date of Birth:',
        oneOfTheFollowing: 'One of the following:',
        enterCardNumber: (cardName) => `Enter the ${cardName}`,
        title: 'Forgotten Card'
    },
    cards: {
        _self: 'Cards',
        readingCard: 'Reading card',
        fetchingCard: 'Fetching card data',
        lookingUpPerson: 'Looking up person',
        matchFound: 'A match has been found',
        noMatchFound: 'No match was found',
        noMatchFoundWarning: 'No match was found, please check and try again',
        cardNotFoundMessage: 'Card not found, it may be part of another scheme (check first two digits of card number match those for your version)',
        blocksPresent: 'There are no blocks for this person',
        dateFrom: 'Date from',
        caseNumber: 'Case reference number',
        currentBlocksHeader: 'Current suspensions',
        networkName: 'Entity',
        siteName: 'Site',
        cardDetails: 'Card details',
        blocksPresentAlert: 'Suspensions exist for this person',
        cardholderOverviewHeader: 'Card holder overview',
        newToIndustry: 'New to the industry',
        checkedWithDatabase: 'Checked with database',
        employer: 'Employer',
        jobRole: 'Job role',
        cardDetailsTab: 'Card details',
        blocksTab: 'Current suspensions',
        jobRolesTab: 'Job roles',
        jobRolesTitle: 'Job roles',
        nationalCompetenciesTab: 'National',
        nationalCompetenciesTitle: 'National competencies',
        employerCompetenciesTab: 'Employer',
        employerCompetenciesTitle: 'Employer competencies',
        namedCompetenciesTitle: (name) => `${name} competencies`,
        siteOrZoneCompetenciesTab: (siteOrZoneName) => `${siteOrZoneName} based`,
        siteOrZoneCompetenciesTitle: (siteOrZoneName) => `${siteOrZoneName} based competencies`,
        cscsCardsTab: 'Compatible Skills Card',
        cscsCardsTitle: 'Compatible Skills Card',
        competencyTitle: 'Title',
        competencyExpiryDate: 'Expiry date',
        fatigueInformationHeader: 'Fatigue information',
        fatigueInformationSubtitle: 'Note: Swipes completed on a separate device whilst offline may not yet be visible',
        linkedSchemeLabel: 'Linked Scheme',
        travelTimeFrom: 'Travel time',
        travelTimeTo: 'Travel time',
        travelToSite: 'Travel to site (from place of rest)',
        travelFromSite: 'Travel from site (to place of rest)',
        fuelTypeFrom: 'Fuel type',
        fuelTypeTo: 'Fuel type',
        travelMethodFrom: 'Travel method',
        travelMethodTo: 'Travel method',
        travelDistanceFrom: 'Travel distance',
        travelDistanceTo: 'Travel distance',
        timeSinceLastSwipe: 'Time since last swipe out',
        stillSwipedIn: 'Still swiped in',
        previousLocations: 'Recent swipes',
        site: 'Site',
        timeIn: 'Time swiped in',
        timeOut: 'Time swiped out',
        lastShiftDuration: 'Last shift duration',
        travelTime: 'Travel Time',
        travelTimeFromPlaceOfRest:'From',
        travelTimeToPlaceOfRest:'To',
        previousSite: 'Previous site',
        timeSwipedIn: 'Time swiped in',
        timeSwipedOut: 'Time swiped out',
        noJobRoles: 'There are no job roles assigned to this person',
        missingCompetenciesAll: 'All of the following:',
        missingCompetenciesAtLeast: 'At least one of the following:',
        missingCompetenciesHeader: 'Missing requirements:',
        invalidCompetenciesFor: 'Invalid requirements for ',
        restrictionsHeader: 'Restrictions',
        breathalyserHeader: 'Breathalyser Testing',
        breathalyserLastSiteTest: (dateString) => `Last site breathalyser test: ${dateString}`,
        maxNumberOfCardlessSwipesExceeded: 'Manual Swipe limit exceeded'
    },
    swipes: {
        _self: 'Swipes',
        uploadingSwipe: 'Uploading swipe data...',
        uploadFailure: 'Failed to upload swipe: ',
        denyReasonDialogTitle: 'Select Reason',
        denyReasonDialogMessage: 'Please select the reason why this swipe in has been denied.',
        deny: 'Deny'        
    },
    scan: {
        _self: 'Scans',
        scanQrCodeTitle: 'Scan your QR Code',
    },
    spotCheck: {
        _self: 'Spot Checks'
    },
    swipeIn: {
        _self: 'Swipe In',
        denySwipe: 'Deny Swipe',
        confirmSwipe: 'Confirm Swipe',
    },
    swipeOut: {
        _self: 'Swipe Out'
    },
    visitorPass: {
        _self: 'Visitor Pass',
    },
    competencies: {
        _self: 'Competencies',
        requirements: {
            sectionHeader: (scope) => `${scope} requirements`
        },
        allOf: 'All of the following:',
        oneOf: 'At least one of the following:',
        scheduledDetails: 'Select a competency from the list below and click Proceed',
        noScheduledCompetencesFor: (name) => `There are no scheduled site based requirements for ${name}`,
        theFollowingCompetenciesAreScheduled: (siteNameLabel, siteName) => `The following ${siteNameLabel}-based requirements are scheduled for ${siteName}.`,
        pleaseEnsureTheyAreDelivered: 'Please ensure that you deliver them to the appropriate people, by the date specified.',
        markAsComplete: 'Mark as complete',
        award: 'Award',
        expiryDateLabel: 'Expiry Date:',
        locationRequirements: 'Location requirements',
        noRequirementsAtLocation: 'There are no requirements for the current location'
    },
    general: {
        ok: 'OK',
        cancel: 'Cancel',
        close: 'Close',
        find: 'Find',
        show: 'Show',
        hours: 'Hours',
        minutes: 'Minutes',
        update: 'Update',
        pleaseSelect: 'Please select'
    },
    pages: {
        login: {
            title: (productName) => `Log in to ${productName}`,
            loginHeader: (productName) => `Log in to ${productName}`,
            loginMessage: (productName) => `Log in by scanning the QR code on your physical or virtual ${productName} card`,
            useCamera: 'Use Camera',
            useScanner: 'Use QR Scanner',
            cannotLogInWithVisitorPass: 'Sorry, you cannot log in with a visitor pass'
        },
        swipes: {
            denySwipeResponsive: (isTiny) => isTiny ? 'Deny' : 'Deny Swipe',
            confirmSwipeResponsive: (isTiny) => isTiny ? 'Confirm' : 'Confirm Swipe',
        }
    }
};

export default messages;